import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const BusinessAdministrationHeader = () => {
  return (
    <CourseHeader
      title="Business"
      highlight="Administration"
      subtitle="Lead. Manage. Succeed."
      backgroundImage="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2072&q=80"
    />
  );
};

export default BusinessAdministrationHeader;
